export enum DatabookVersionEnum {
  Online = 1,
  Offline = 2,
  PowerPivot = 3
}
